import { useState, useEffect } from "react";

export default function UploadPage() {
  useEffect(() => {
    fetch("/api/check-auth")
      .then((res) => {
        if (!res.ok) window.location.href = "/login";
      });
  }, []);
  
  const [formData, setFormData] = useState({
    image_url: "",
    title: "",
    date: "",
    location: "",
    description: "",
    instagram: "",
    file: null,
  });

  const [preview, setPreview] = useState(null);

  const handleChange = (e) => {
  const { name, value, files } = e.target;
  if (files) {
    const fileArray = Array.from(files);
    setFormData((prev) => ({ ...prev, file: fileArray }));

    // Crea anteprime solo per immagini
    const previews = fileArray
      .filter(file => file.type.startsWith("image/"))
      .map(file => URL.createObjectURL(file));
    setPreview(previews);
  } else {
    setFormData((prev) => ({ ...prev, [name]: value }));
  }
};

  const [projects, setProjects] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState("");

  useEffect(() => {
    fetch("/api/retrieve-project-names")
      .then((res) => res.json())
      .then((data) => setProjects(data));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check: almeno uno tra file o image_url deve essere presente
    if (!formData.file && (!formData.image_url || formData.image_url.trim() === "")) {
      alert("Devi selezionare un file o fornire un URL dell'immagine.");
      return;
    }

    const data = new FormData();
    
    if (formData.file && Array.isArray(formData.file)) {
      formData.file.forEach((file, i) => {
        data.append("file", file); // nome generico: 'files'
      });
    } else if (formData.file) {
      console.log("File presente");
      data.append("file", formData.file); // solo se presente
    } else
    console.log("File NON C'E'");

    data.append('image_url', formData.image_url);
    data.append('title', formData.title);
    data.append('date', formData.date);
    data.append('location', formData.location);
    data.append('description', formData.description);
    data.append('instagram', formData.instagram);
    if (selectedProjectId) {
      data.append('project_id', selectedProjectId);
    }


    try {
      const res = await fetch("/api/upload", {
        method: "POST",
        body: data,
      });
      const result = await res.json();
      if (!res.ok) throw new Error(result.error || "Errore generico");
      
      console.log("Upload riuscito:", result);
      alert("Caricamento avvenuto con successo.");
    
    } catch (err) {
      return new Response(
        JSON.stringify({
          error: "Errore interno",
          message: err.message,
          stack: err.stack,
        }),
        {
          status: 500,
          headers: { "Content-Type": "application/json" },
        }
      );
    }
    
  };

  return (
    <div className="p-4 max-w-md mx-auto">
      <header className="flex justify-between items-center pb-4 border-b">
        <h1 className="text-lg font-bold">Upload Foto</h1>
        <button className="text-lg" onClick={() => window.history.back()}>↩</button>
      </header>

      <form className="space-y-4 mt-6" onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="relative w-full h-48 border rounded flex items-center justify-center overflow-hidden">
          <div className="grid grid-cols-3 gap-2">
            {preview?.map((src, idx) => (
              <img
                key={idx}
                src={src}
                alt={`preview-${idx}`}
                className="w-full h-32 object-cover rounded"
              />
            ))}
          </div>
          {selectedProjectId ? (
            <input
            type="file"
            accept="image/*,video/*"
            name="file"
            multiple
            onChange={handleChange}
            className="absolute inset-0 opacity-0 cursor-pointer"
          />
          ) : (
            <input
            type="file"
            accept="image/*,video/*"
            name="file"
            onChange={handleChange}
            className="absolute inset-0 opacity-0 cursor-pointer"
          />
          )}
        </div>
          <br/> &emsp; oppure
        <input
          type="text"
          name="image_url"
          placeholder="URL immagine (sconsigliato)"
          value={formData.image_url}
          onChange={handleChange}
          
          className="w-full border p-2 rounded"
        />

        <label> <ln/>
          Progetto di appartenenza (opzionale):
          <select
            value={selectedProjectId}
            className="w-full border p-2 rounded"
            onChange={(e) => setSelectedProjectId(e.target.value)}
          >
            <option value="">— Nessuno (nuovo progetto) —</option>
            {projects.map((p) => (
              <option key={p.id} value={p.id}>
                {p.title} — {p.location}, {p.date}
              </option>
            ))}
          </select>
        </label>

        <input
          type="text"
          name="title"
          placeholder="Titolo"
          value={formData.title}
          onChange={handleChange}
          required={!selectedProjectId}
          disabled={!!selectedProjectId}
          className="w-full border p-2 rounded"
        />
        <input
          type="date"
          name="date"
          placeholder="Data"
          value={formData.date}
          onChange={handleChange}
          required={!selectedProjectId}
          disabled={!!selectedProjectId}
          className="w-full border p-2 rounded"
        />
        <input
          type="text"
          name="location"
          placeholder="Luogo"
          value={formData.location}
          onChange={handleChange}
          required={!selectedProjectId}
          disabled={!!selectedProjectId}
          className="w-full border p-2 rounded"
        />
        <input
          type="text"
          name="instagram"
          placeholder="Link Instagram"
          value={formData.instagram}
          onChange={handleChange}
          disabled={!!selectedProjectId}
          className="w-full border p-2 rounded"
        />
        <textarea
          name="description"
          placeholder="Descrizione"
          value={formData.description}
          onChange={handleChange}
          disabled={!!selectedProjectId}
          className="w-full border p-2 rounded"
        />
        <button type="submit" className="w-full bg-black text-white p-2 rounded hover:bg-gray-800">
          Carica
        </button>
      </form>
    </div>
  );
}

